import { type LucideIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface PortalEmptyStateProps {
  icon: LucideIcon
  message: string
  actionLabel?: string
  onAction?: () => void
  className?: string
}

/** Standard empty-state block: icon + one sentence + optional CTA. */
export function PortalEmptyState({ icon: Icon, message, actionLabel, onAction, className }: PortalEmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center gap-3 rounded-xl border border-dashed border-border bg-muted/30 py-12 px-6',
        className
      )}
    >
      <div className="w-11 h-11 rounded-full bg-muted flex items-center justify-center">
        <Icon className="w-5 h-5 text-muted-foreground" />
      </div>
      <p className="text-sm text-muted-foreground max-w-sm">{message}</p>
      {actionLabel && onAction && (
        <Button size="sm" className="h-11 px-4" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
